module.exports = __webpack_public_path__ + "img/web-P4-0-3.9f2123d0.svg";